import Container from "react-bootstrap/Container";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Outlet } from "react-router-dom";
import Myfooter from "./footer";

function MyNavigation() {
  return (
    <div>
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/">BlockChain Johor</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto d-flex">
            <Nav.Link href="/CreateAccount">Akaun Baru</Nav.Link>
            <Nav.Link href="/CheckBalance">Semak Akaun</Nav.Link>
            <Nav.Link href="/Transfer">Pindah Dana</Nav.Link>
            <Nav.Link href="/StorageApp">Simpan Dana</Nav.Link>
            <Nav.Link href="/MarketPlace">Kedai Runcit</Nav.Link>
            <Nav.Link href="/Token">ICTJohorCoin</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    <Container fluid>
      <Outlet />
    </Container>
    <Myfooter />
    </div>
  );
}

export default MyNavigation;